import { DateFormat, transformDate } from 'shared/entities/date';

export const formatNewsPublishDate = (
  publishDate: string | null
): string | undefined => {
  if (!publishDate) {
    return undefined;
  }

  const date = new Date(publishDate);

  return Number.isNaN(date.getTime())
    ? undefined
    : transformDate(date, DateFormat.dayMonthYearTime);
};
